/**
 * Helper to invalidate local query caches after an IndexedDB write.
 * Must use the same Jotai store instance as the React Provider so the
 * queryClient atom reads land on the same client.
 */
import { queryClientAtom } from 'jotai-tanstack-query'
import { appStore } from '@/appStore'

export async function invalidateLocalData() {
  const qc = appStore.get(queryClientAtom)
  await qc.invalidateQueries({ queryKey: ['HomeStore'] })
  await qc.invalidateQueries({ queryKey: ['SettingsStore'] })
}
